import { onMounted } from "vue";
import { a as focusElement, b as blurElement } from "../utils/focus.js";
import { u as unwrapEl } from "../utils/unwrapEl.js";
const useFocusableProps = {
  /** Focus element when mounted */
  autofocus: { type: Boolean, default: false }
};
const useFocusable = (el, props) => {
  const focus = () => {
    focusElement(unwrapEl(el.value));
  };
  const blur = () => {
    blurElement(unwrapEl(el.value));
  };
  onMounted(() => {
    if (props.autofocus) {
      focus();
    }
  });
  return {
    focus,
    blur
  };
};
export {
  useFocusable as a,
  useFocusableProps as u
};
//# sourceMappingURL=useFocusable.js.map
